/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnsureEmailValidityRequest } from '../../models/ensure-email-validity-request';
import { EnsureEmailValidityWithSsoResult } from '../../models/ensure-email-validity-with-sso-result';

export interface PostEnsureEmailValidityWithSso$Params {
  body?: EnsureEmailValidityRequest;
}

export function postEnsureEmailValidityWithSso(
  http: HttpClient,
  rootUrl: string,
  params?: PostEnsureEmailValidityWithSso$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<EnsureEmailValidityWithSsoResult>> {
  const rb = new RequestBuilder(rootUrl, postEnsureEmailValidityWithSso.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnsureEmailValidityWithSsoResult>;
    }),
  );
}

postEnsureEmailValidityWithSso.PATH = '/Registration/ensure-email-validity-with-sso';
